import AuthenticatedLeadFormsConstants from '../../../constants/AuthenticatedLeadForms';
const {
  CashoutSuccessMessage,
  CashoutErrorMessage,
  RefinanceErrorMessage,
  RefinanceSuccessMessage,
  PurchaseErrorMessage,
  PurchaseSuccessMessage
} = AuthenticatedLeadFormsConstants;
const SuccessMessage = type => {
  switch (type) {
    case 'AuthCashOut':
      return CashoutSuccessMessage;
    case 'AuthRefi':
      return RefinanceSuccessMessage;
    case 'AuthPurchase':
      return PurchaseSuccessMessage;
    default:
      return '';
  }
};
const ErrorMessage = type => {
  switch (type) {
    case 'AuthCashOut':
      return CashoutErrorMessage;
    case 'AuthRefi':
      return RefinanceErrorMessage;
    case 'AuthPurchase':
      return PurchaseErrorMessage;
    default:
      return '';
  }
};
const AuthenticatedLeadFormsResponseFunctions = {
  SuccessMessage,
  ErrorMessage
};
export default AuthenticatedLeadFormsResponseFunctions;
//# sourceMappingURL=index.js.map